import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface EstimateRequest {
    // category: string;
    limit: string;
    page: number;
    from_date: string;
    to_date: string;
}
export type DataListProps = {
    list_no: number;
    w_date: string;
    e_company: string;
    e_name: string;
    e_tel: string;
    e_email: string;
    e_end: string;
    result: string;
    result_text: string;
};

export interface EstimateResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleEstimate = (data: EstimateRequest | null): UseQueryResult<EstimateResponse, Error> => {
    let url = enum_api_uri.get_console_estimate;
    return useQuery({
        queryKey: ["useGetConsoleEstimate", data],
        queryFn: async () => {
            if (!data) throw new Error("Invalid request data");
            const response = await axiosInstance.get(url, {
                params: {
                    limit: data.limit,
                    page: data.page,
                    from_date: data.from_date,
                    to_date: data.to_date,
                },
            });
            return response.data.data;
        },
        enabled: !!data,
    });
};
